/**
 * 清空抽屉中生成的图片和预览
 */
function clearGeneratedImagesInDrawer(drawer) {

  // 1. 清空图片网格
  const imagesGrid = drawer.querySelector('#select-image-list');
  if (imagesGrid) {
    imagesGrid.innerHTML = '';
  }

  // 2. 重置隐藏的图片 URL 输入框
  // 通过 ID 直接清空（更可靠）
  const hidden1 = drawer.querySelector('#ai-custom-image-url');
  const hidden2 = drawer.querySelector('#ai-custom-image-url-2');
  const display1 = drawer.querySelector('#ai-custom-image-url-display');
  const display2 = drawer.querySelector('#ai-custom-image-url-2-display');

  if (hidden1 && hidden1.value) {
    hidden1.value = '';
  }

  if (hidden2 && hidden2.value) {
    hidden2.value = '';
  }

  if (display1 && display1.value) {
    display1.value = '';
  }

  if (display2 && display2.value) {
    display2.value = '';
  }

  // 额外清空任何其他可能存在的 Custom Image 输入框
  const extraHiddenInputs = drawer.querySelectorAll('input[name*="Custom Image"]');
  extraHiddenInputs.forEach(input => {
    if (input.value && input !== hidden1 && input !== hidden2) {
      input.value = '';
    }
  });

  // 3. 清空图片预览
  const previewImages = drawer.querySelectorAll('#ai-upload-preview, #ai-upload-preview-2');
  previewImages.forEach(img => {
    if (img) {
      img.src = '';
    }
  });

  // 4. 重置上传状态文本
  const statusDivs = drawer.querySelectorAll('#ai-upload-status, #ai-upload-status-2');
  statusDivs.forEach(div => {
    if (div) {
      div.textContent = '';
      div.className = 'ai-upload-status';
    }
  });

  // 5. 重置上传按钮状态
  const uploadButtons = drawer.querySelectorAll('#ai-upload-trigger, #ai-upload-trigger-2');
  uploadButtons.forEach(btn => {
    if (btn) {
      btn.classList.remove('has-image', 'validation-error');
      const buttonText = btn.querySelector('.button-text, .ai-upload-text');
      if (buttonText) {
        buttonText.textContent = 'Upload Photo';
      }
    }
  });

  // 6. 重置全局上传弹窗状态（如果存在）
  if (window.globalUploadModal) {
    window.globalUploadModal.selectedImageUrl = null;
  }

}

// 为抽屉中的上传组件初始化 ImageUploader（改进版 v2）
function initDrawerUploaders(drawer) {

  // 检查必需的类和全局对象
  if (typeof ImageUploader === 'undefined' || typeof window.globalUploadModal === 'undefined') {
    console.error('[Drawer Upload] ImageUploader or GlobalUploadModal not loaded');
    return false; // 返回false表示初始化失败
  }

  // 初始化第一个上传器
  const trigger1 = drawer.querySelector('#ai-upload-trigger');
  const input1 = drawer.querySelector('#ai-file-input');
  const hidden1 = drawer.querySelector('#ai-custom-image-url');


  let uploader1Initialized = false;
  if (trigger1 && input1 && hidden1 && !trigger1.dataset.uploaderInitialized) {
    trigger1.dataset.uploaderInitialized = 'true';

    const uploader1 = new ImageUploader({
      // API 配置（apiBaseUrl 使用默认值）
      uploadEndpoint: '/models/createModelsFromImages',
      pollEndpoint: '/jobs/queryStatus',
      tokenStorageKey: 'deliver3d_guest_token',
      jobNum: 2,
      sourceType: 'cute_single_img2img_deliver3d_long',
      defaultStyle: 'Q-Style',
      onImageSelect: (url) => {
        const preview = drawer.querySelector('#ai-upload-preview');
        const status = drawer.querySelector('#ai-upload-status');
        if (preview) preview.src = url;
        if (trigger1) {
          trigger1.classList.add('has-image');
          trigger1.classList.remove('validation-error');
        }
        if (status) {
          status.textContent = '✓ Design selected!';
          status.className = 'ai-upload-status success';
        }
      },
      onUploadError: (error) => {
        const status = drawer.querySelector('#ai-upload-status');
        if (status) {
          status.textContent = '✗ Upload failed: ' + error.message;
          status.className = 'ai-upload-status error';
        }
      }
    });

    // 使用元素对象而不是选择器字符串进行初始化
    uploader1.init(trigger1, input1, hidden1);
    uploader1Initialized = true;

    // 额外验证：确认点击事件已绑定
    setTimeout(() => {
      const hasClickListener = trigger1.onclick !== null ||
                               trigger1.getAttribute('onclick') !== null;
    }, 100);

    // 删除按钮
    const removeBtn1 = drawer.querySelector('#ai-upload-remove');
    if (removeBtn1 && !removeBtn1.dataset.listenerAdded) {
      removeBtn1.dataset.listenerAdded = 'true';
      removeBtn1.addEventListener('click', (e) => {
        e.stopPropagation();
        const preview = drawer.querySelector('#ai-upload-preview');
        const status = drawer.querySelector('#ai-upload-status');
        if (preview) preview.src = '';
        if (trigger1) trigger1.classList.remove('has-image');
        if (hidden1) hidden1.value = '';
        if (status) {
          status.textContent = '';
          status.className = 'ai-upload-status';
        }
      });
    }
  } else if (!trigger1 || !input1 || !hidden1) {
    console.warn('[Drawer Upload] Uploader 1 elements not found in drawer');
    return false;
  } else if (trigger1?.dataset.uploaderInitialized === 'true') {
    uploader1Initialized = true; // 如果已经初始化过，也算成功
  }

  // 初始化第二个上传器
  const trigger2 = drawer.querySelector('#ai-upload-trigger-2');
  const input2 = drawer.querySelector('#ai-file-input-2');
  const hidden2 = drawer.querySelector('#ai-custom-image-url-2');


  let uploader2Initialized = false;
  if (trigger2 && input2 && hidden2 && !trigger2.dataset.uploaderInitialized) {
    trigger2.dataset.uploaderInitialized = 'true';

    const uploader2 = new ImageUploader({
      // API 配置（apiBaseUrl 使用默认值）
      uploadEndpoint: '/models/createModelsFromImages',
      pollEndpoint: '/jobs/queryStatus',
      tokenStorageKey: 'deliver3d_guest_token',
      jobNum: 2,
      sourceType: 'cute_single_img2img_deliver3d_long',
      defaultStyle: 'Q-Style',
      onImageSelect: (url) => {
        const preview = drawer.querySelector('#ai-upload-preview-2');
        const status = drawer.querySelector('#ai-upload-status-2');
        if (preview) preview.src = url;
        if (trigger2) {
          trigger2.classList.add('has-image');
          trigger2.classList.remove('validation-error');
        }
        if (status) {
          status.textContent = '✓ Design selected!';
          status.className = 'ai-upload-status success';
        }
      },
      onUploadError: (error) => {
        const status = drawer.querySelector('#ai-upload-status-2');
        if (status) {
          status.textContent = '✗ Upload failed: ' + error.message;
          status.className = 'ai-upload-status error';
        }
      }
    });

    // 使用元素对象而不是选择器字符串进行初始化
    uploader2.init(trigger2, input2, hidden2);
    uploader2Initialized = true;

    // 额外验证：确认点击事件已绑定
    setTimeout(() => {
      const hasClickListener = trigger2.onclick !== null ||
                               trigger2.getAttribute('onclick') !== null;
    }, 100);

    // 删除按钮
    const removeBtn2 = drawer.querySelector('#ai-upload-remove-2');
    if (removeBtn2 && !removeBtn2.dataset.listenerAdded) {
      removeBtn2.dataset.listenerAdded = 'true';
      removeBtn2.addEventListener('click', (e) => {
        e.stopPropagation();
        const preview = drawer.querySelector('#ai-upload-preview-2');
        const status = drawer.querySelector('#ai-upload-status-2');
        if (preview) preview.src = '';
        if (trigger2) trigger2.classList.remove('has-image');
        if (hidden2) hidden2.value = '';
        if (status) {
          status.textContent = '';
          status.className = 'ai-upload-status';
        }
      });
    }
  } else if (trigger2?.dataset.uploaderInitialized === 'true') {
    uploader2Initialized = true; // 如果已经初始化过，也算成功
  } else {
    // 第二个上传器不存在是正常的（不是情侣产品）
    uploader2Initialized = true; // 不需要第二个上传器也算成功
  }

  const success = uploader1Initialized; // 至少第一个上传器要初始化成功
  return success;
}

// 为抽屉中的表单添加校验
function addDrawerFormValidation(form, drawer) {
  if (form.dataset.validationAdded === 'true') return;
  form.dataset.validationAdded = 'true';

  // 校验函数
  function validateForm() {
    // 如果是饰品类商品（没有上传组件），不需要验证图片
    const uploadContainer = drawer.querySelector('.ai-upload-container');
    if (!uploadContainer) {
      return true;
    }

    const hidden1 = drawer.querySelector('#ai-custom-image-url');
    const hidden2 = drawer.querySelector('#ai-custom-image-url-2');
    const container2 = drawer.querySelector('.ai-upload-container[data-upload-index="2"]');

    // 检查第二个上传框是否可见
    const isSecondUploaderVisible = container2 && container2.style.display !== 'none';

    const hasImage1 = hidden1 && hidden1.value.trim() !== '';
    const hasImage2 = !isSecondUploaderVisible || (hidden2 && hidden2.value.trim() !== '');

    if (!hasImage1) {
      const trigger1 = drawer.querySelector('#ai-upload-trigger');
      const status1 = drawer.querySelector('#ai-upload-status');

      if (trigger1) {
        trigger1.classList.add('validation-error');
        trigger1.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (status1) {
        status1.textContent = '';
        status1.className = 'ai-upload-status error';
      }

      return false;
    }

    if (isSecondUploaderVisible && !hasImage2) {
      const trigger2 = drawer.querySelector('#ai-upload-trigger-2');
      const status2 = drawer.querySelector('#ai-upload-status-2');

      if (trigger2) {
        trigger2.classList.add('validation-error');
        trigger2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (status2) {
        status2.textContent = '';
        status2.className = 'ai-upload-status error';
      }

      return false;
    }

    return true;
  }

  // 拦截表单提交事件（捕获阶段）
  form.addEventListener('submit', function(e) {
    if (!validateForm()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // 同时拦截冒泡阶段
  form.addEventListener('submit', function(e) {
    if (!validateForm()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, false);

  // 查找 Add to Cart 按钮并添加点击拦截
  const addToCartButtons = drawer.querySelectorAll('button[type="submit"], button[name="add"], .product-form__add-button');
  addToCartButtons.forEach(button => {
    if (button.dataset.validationListenerAdded === 'true') return;
    button.dataset.validationListenerAdded = 'true';

    // 捕获阶段拦截
    button.addEventListener('click', function(e) {
      if (!validateForm()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  });

  // 为 Shopify Payment Button 添加拦截
  const paymentButtonContainer = form.querySelector('.shopify-payment-button');
  if (paymentButtonContainer) {
    // 使用事件委托在容器上监听所有点击事件
    paymentButtonContainer.addEventListener('click', function(e) {
      if (!validateForm()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, true); // 使用捕获阶段
  }
}

/**
 * Drawer 中 Figure Type 切换时更新 Style swatch 图片
 */
function setupDrawerFigureTypeStyleSync(drawer) {
  if (!drawer) return;

  let figureTypeSelector = null;
  const optionSelectors = drawer.querySelectorAll('.product-form__option-selector');
  optionSelectors.forEach(selector => {
    const nameEl = selector.querySelector('.product-form__option-name');
    if (nameEl && nameEl.textContent.trim().toLowerCase().replace(':', '') === 'choose figure type') {
      figureTypeSelector = selector;
    }
  });

  if (!figureTypeSelector) return;

  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function updateStyleImages() {
    const checkedRadio = figureTypeSelector.querySelector('input[type="radio"]:checked');
    if (!checkedRadio) return;

    const figureType = handleize(checkedRadio.value);
    const styleWrappers = drawer.querySelectorAll('.block-swatch__image-wrapper[data-style-value]');

    styleWrappers.forEach(wrapper => {
      const attrName = 'data-img-' + figureType;
      const newSrc = wrapper.getAttribute(attrName);

      if (newSrc) {
        let img = wrapper.querySelector('img.block-swatch__image');
        if (!img) {
          img = document.createElement('img');
          img.className = 'block-swatch__image';
          img.loading = 'lazy';
          img.alt = wrapper.getAttribute('data-style-value') || '';
          wrapper.appendChild(img);
        }
        img.src = newSrc;
        img.srcset = '';
      }
    });
  }

  const figureRadios = figureTypeSelector.querySelectorAll('input[type="radio"]');
  figureRadios.forEach(radio => {
    radio.addEventListener('change', updateStyleImages);
  });

  updateStyleImages();
}

window.addEventListener('DOMContentLoaded', function() {

  /* color-swatch__item 的显示效果 */
  $('.product-item-meta__swatch-list .color-swatch.more').on('click', function(){
      $(this).hide();
      $(this).parents('.product-item-meta__swatch-list').find('.color-swatch').removeClass('hidden');
  });

  // 防止抽屉在上传过程中被关闭
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const drawer = mutation.target;
        const isOpen = drawer.hasAttribute('open');
        const uploadInProgress = drawer.dataset.uploadInProgress;
        const modalOpen = drawer.dataset.modalOpen;

        // 如果抽屉正在关闭，但有模态框打开或上传在进行中，重新打开它
        if (!isOpen && (modalOpen === 'true' || uploadInProgress === 'true')) {
          setTimeout(() => {
            drawer.setAttribute('open', '');
          }, 0);
        }
      }
    });
  });

  // 观察所有 quick-buy-drawer 元素
  document.querySelectorAll('quick-buy-drawer').forEach((drawer) => {
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  });

  // 为动态添加的抽屉设置观察
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-BUY-DRAWER') {
          observer.observe(node, { attributes: true, attributeFilter: ['open'] });
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // 监听快速购买抽屉中的变体切换（改进版）
  setInterval(() => {
    const openDrawers = document.querySelectorAll('quick-buy-drawer[open]');

    if (openDrawers.length > 0) {
      openDrawers.forEach((drawer) => {
        const drawerForm = drawer.querySelector('form[id*="product-form"]');
        if (drawerForm && drawerForm.dataset.drawerVariantInitialized !== 'true') {
          // 检查表单内容是否已完全加载（通过检查关键元素）
          const uploadTrigger = drawer.querySelector('#ai-upload-trigger');
          const variantIdInput = drawerForm.querySelector('input[name="id"]');

          // variantIdInput 必须存在，uploadTrigger 可以不存在（饰品类商品没有上传组件）
          if (!variantIdInput) {
            return; // 等待下一个interval周期
          }

          drawerForm.dataset.drawerVariantInitialized = 'true';

          // 初始化抽屉中的上传组件（带重试机制）
          // 饰品类商品没有上传组件，initDrawerUploaders 会返回 false，但不影响后续初始化
          const hasUploadComponents = !!uploadTrigger;
          if (hasUploadComponents) {
            const initSuccess = initDrawerUploaders(drawer);
            if (!initSuccess) {
              drawerForm.dataset.drawerVariantInitialized = 'false'; // 重置标记，允许重试
              return;
            }
          }

          // 添加表单校验（仅对有上传组件的商品）
          if (hasUploadComponents) {
            addDrawerFormValidation(drawerForm, drawer);
          }

          // 设置 Figure Type → Style 图片同步
          if (typeof setupPopoverFigureTypeStyleSync === 'function') {
            setupPopoverFigureTypeStyleSync(drawer);
          } else {
            // 内联版本（custom.js 可能没有引入 custom2.js 的函数）
            setupDrawerFigureTypeStyleSync(drawer);
          }

          // 初始化快速购买按钮
          const quickBuyButton = drawer.querySelector('#QuickBuyButton');
          if (quickBuyButton && !quickBuyButton.dataset.quickBuyInitialized) {
            quickBuyButton.dataset.quickBuyInitialized = 'true';

            quickBuyButton.addEventListener('click', async function(e) {
              e.preventDefault();

              // 如果是饰品类商品（没有上传组件），跳过图片验证
              const uploadContainer = drawer.querySelector('.ai-upload-container');
              if (uploadContainer) {
                // 验证图片上传（使用与 Add to Cart 相同的验证逻辑）
                const hidden1 = drawer.querySelector('#ai-custom-image-url');
                const hidden2 = drawer.querySelector('#ai-custom-image-url-2');
                const container2 = drawer.querySelector('.ai-upload-container[data-upload-index="2"]');

                // 检查第二个上传框是否可见
                const isSecondUploaderVisible = container2 && container2.style.display !== 'none';

                const hasImage1 = hidden1 && hidden1.value.trim() !== '';
                const hasImage2 = !isSecondUploaderVisible || (hidden2 && hidden2.value.trim() !== '');

                if (!hasImage1) {
                  const trigger1 = drawer.querySelector('#ai-upload-trigger');
                  const status1 = drawer.querySelector('#ai-upload-status');

                  if (trigger1) {
                    trigger1.classList.add('validation-error');
                    trigger1.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }

                  if (status1) {
                    status1.textContent = '';
                    status1.className = 'ai-upload-status error';
                  }
                  return;
                }

                if (isSecondUploaderVisible && !hasImage2) {
                  const trigger2 = drawer.querySelector('#ai-upload-trigger-2');
                  const status2 = drawer.querySelector('#ai-upload-status-2');

                  if (trigger2) {
                    trigger2.classList.add('validation-error');
                    trigger2.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }

                  if (status2) {
                    status2.textContent = '';
                    status2.className = 'ai-upload-status error';
                  }
                  return;
                }
              }


              // 显示加载状态
              const buttonText = quickBuyButton.querySelector('.quick-buy-text');
              const originalText = buttonText ? buttonText.textContent : 'Buy Now';
              if (buttonText) buttonText.textContent = 'Processing...';
              quickBuyButton.disabled = true;

              try {
                const formData = new FormData(drawerForm);
                const properties = Object.fromEntries(
                  Array.from(formData.entries())
                    .filter(([key, value]) => key.startsWith('properties[') && String(value).trim() !== '')
                    .map(([key, value]) => [key.match(/properties\[(.*?)\]/)[1], value])
                );

                if (uploadContainer && !properties['Generated Image']) {
                  throw new Error('Generated Image is required');
                }

                // 使用 /cart/add.js API 添加商品
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify({
                    items: [{
                      id: formData.get('id'),
                      quantity: formData.get('quantity') || 1,
                      properties: properties
                    }]
                  })
                });

                if (!response.ok) {
                  throw new Error('Failed to add to cart');
                }

                // 跳转到结账页面
                window.location.href = '/checkout';

              } catch (error) {
                console.error('[Quick Buy] Error:', error);
                alert('Failed to process quick buy. Please try again.');

                // 恢复按钮状态
                if (buttonText) buttonText.textContent = originalText;
                quickBuyButton.disabled = false;
              }
            });
          }

          // 获取变体元字段数据 - 使用 class 选择器因为 ID 现在是唯一的
          const metafieldScript = drawer.querySelector('.variant-metafields-data');
          let variantMetafields = {};

          if (metafieldScript) {
            try {
              const data = JSON.parse(metafieldScript.textContent);
              variantMetafields = data.variantMetafields || {};
            } catch (e) {
              console.error('[Quick Buy Drawer] Failed to parse metafield data:', e);
            }
          }

          // 监听变体切换
          // variantIdInput 已经在前面声明过了（第316行），这里直接使用
          if (!variantIdInput) return;

          // 用于跟踪之前的所有样式相关选项的状态
          let previousStyleState = null;
          let styleOptionPositions = []; // 存储所有样式相关选项的位置
          let styleRadioListenersAdded = false;

          // 检查并切换上传框显示
          function checkAndToggleUploader() {
            const currentVariantId = variantIdInput.value;

            // 尝试找到所有样式相关选项（只在第一次运行时查找）
            if (styleOptionPositions.length === 0) {

              // 方法1: 查找带有样式相关文本的 label 或 legend
              const allLabels = drawer.querySelectorAll('label, legend, .product-form__option-name, [class*="option"], [class*="label"]');

              allLabels.forEach((el, index) => {
                const text = el.textContent.trim().toLowerCase();

                // 检查是否是样式相关选项
                const isStyleOption =
                  text.includes('choose your style') ||
                  text.includes('choose figure type') ||
                  text === 'style' ||
                  text === 'choose style';

                if (isStyleOption) {
                  // 找到包含这个 label 的选项组，确定是哪个 option
                  let currentEl = el;
                  while (currentEl && currentEl !== drawer) {
                    // 查找同级或父级的 radio buttons
                    const nearbyRadios = currentEl.querySelectorAll('input[type="radio"][name^="option"]');
                    if (nearbyRadios.length > 0) {
                      const radioName = nearbyRadios[0].name; // 例如 "option2"
                      const match = radioName.match(/option(\d+)/);
                      if (match) {
                        const position = parseInt(match[1]);
                        // 避免重复添加
                        if (!styleOptionPositions.includes(position)) {
                          styleOptionPositions.push(position);
                        }
                        break;
                      }
                    }
                    currentEl = currentEl.parentElement;
                  }
                }
              });

              // 方法2: 如果上面没找到，尝试通过值来识别样式选项
              if (styleOptionPositions.length === 0) {
                for (let i = 1; i <= 3; i++) {
                  const radios = drawer.querySelectorAll(`input[name="option${i}"]`);
                  if (radios.length > 0) {
                    const values = Array.from(radios).map(r => r.value.toLowerCase());
                    const hasStyleValue = values.some(v =>
                      v.includes('person') ||
                      v.includes('people') ||
                      v.includes('pet') ||
                      v.includes('chibi') ||
                      v.includes('pixar') ||
                      v.includes('minecraft') ||
                      v.includes('funko') ||
                      v.includes('realistic')
                    );
                    if (hasStyleValue && !styleOptionPositions.includes(i)) {
                      styleOptionPositions.push(i);
                    }
                  }
                }
              }

            }

            // 获取当前所有样式选项的状态
            const currentStyleState = {};
            if (styleOptionPositions.length > 0) {
              styleOptionPositions.forEach(position => {
                const styleRadio = drawer.querySelector(`input[name="option${position}"]:checked`);
                const value = styleRadio?.value || null;
                currentStyleState[`option${position}`] = value;
              });

              // 为所有样式选项的 radio 按钮添加事件监听器（只添加一次）
              if (!styleRadioListenersAdded) {
                styleOptionPositions.forEach(position => {
                  const allStyleRadios = drawer.querySelectorAll(`input[name="option${position}"]`);

                  allStyleRadios.forEach(radio => {
                    radio.addEventListener('change', () => {
                      setTimeout(checkAndToggleUploader, 100);
                    });
                  });
                });
                styleRadioListenersAdded = true;
              }
            }


            // 检测任何样式选项的变化并清空生成的图片
            if (previousStyleState !== null && Object.keys(currentStyleState).length > 0) {
              let hasChanged = false;
              const changes = [];

              // 检查每个样式选项是否发生变化
              for (const optionKey in currentStyleState) {
                if (currentStyleState[optionKey] !== previousStyleState[optionKey]) {
                  hasChanged = true;
                  changes.push(`${optionKey}: ${previousStyleState[optionKey]} → ${currentStyleState[optionKey]}`);
                }
              }

              // 检查是否有选项被移除
              for (const optionKey in previousStyleState) {
                if (!(optionKey in currentStyleState)) {
                  hasChanged = true;
                  changes.push(`${optionKey}: removed`);
                }
              }

              if (hasChanged) {
                clearGeneratedImagesInDrawer(drawer);
              }
            }

            // 更新状态（深拷贝）
            if (Object.keys(currentStyleState).length > 0) {
              previousStyleState = { ...currentStyleState };
            }

            // 切换第二个上传框的显示
            if (variantMetafields[currentVariantId]) {
              const isdouble = variantMetafields[currentVariantId].isdouble;
              const shouldShow = (isdouble === 'yes');

              const container2 = drawer.querySelector('.ai-upload-container[data-upload-index="2"]');
              if (container2) {
                container2.style.display = shouldShow ? 'flex' : 'none';
                const col2 = container2.closest('.ai-upload-col');
                if (col2) col2.style.display = shouldShow ? 'block' : 'none';

                // 如果隐藏第二个上传框，清空其数据，防止残留值被提交到购物车
                if (!shouldShow) {
                  const hiddenInput2 = drawer.querySelector('#ai-custom-image-url-2');
                  const displayInput2 = drawer.querySelector('#ai-custom-image-url-2-display');
                  const uploadBtn2 = drawer.querySelector('#ai-upload-trigger-2');
                  const previewImg2 = drawer.querySelector('#ai-upload-preview-2');
                  const statusDiv2 = drawer.querySelector('#ai-upload-status-2');

                  if (hiddenInput2) hiddenInput2.value = '';
                  if (displayInput2) displayInput2.value = '';
                  if (uploadBtn2) {
                    uploadBtn2.classList.remove('has-image', 'validation-error');
                    const buttonText = uploadBtn2.querySelector('.button-text, .ai-upload-text');
                    if (buttonText) buttonText.textContent = 'Upload Photo';
                  }
                  if (previewImg2) previewImg2.src = '';
                  if (statusDiv2) {
                    statusDiv2.textContent = '';
                    statusDiv2.className = 'ai-upload-status';
                  }
                }
              }
            }
          }

          // 初始检查
          checkAndToggleUploader();

          // 监听 input value 变化
          const observer = new MutationObserver(() => {
            checkAndToggleUploader();
          });

          observer.observe(variantIdInput, {
            attributes: true,
            attributeFilter: ['value']
          });

          // 轮询作为后备方案
          let lastVariantId = variantIdInput.value;
          setInterval(() => {
            const currentVariantId = variantIdInput.value;
            if (currentVariantId !== lastVariantId) {
              lastVariantId = currentVariantId;
              checkAndToggleUploader();
            }
          }, 500);
        }
      });
    }
  }, 500);

  /* 修复数量选择器按钮功能 */
  // 初始化单个 quantity-selector 的函数
  function fixQuantitySelector(selector) {
    if (selector.dataset.quantityFixed === 'true') return;
    selector.dataset.quantityFixed = 'true';

    const inputElement = selector.querySelector('input[is="input-number"]');
    const buttons = selector.querySelectorAll('button');

    if (inputElement && buttons.length === 2) {
      const [decreaseBtn, increaseBtn] = buttons;

      // 减少数量按钮
      decreaseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentQty = parseInt(inputElement.value) || 1;
        const newQty = Math.max(1, currentQty - 1);
        inputElement.value = newQty;
        // 触发 change 事件以便其他逻辑可以响应
        inputElement.dispatchEvent(new Event('change', { bubbles: true }));
      }, true); // 使用捕获阶段确保优先执行

      // 增加数量按钮
      increaseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentQty = parseInt(inputElement.value) || 1;
        const newQty = currentQty + 1;
        inputElement.value = newQty;
        // 触发 change 事件以便其他逻辑可以响应
        inputElement.dispatchEvent(new Event('change', { bubbles: true }));
      }, true); // 使用捕获阶段确保优先执行
    }
  }

  // 等待 customElements 定义完成
  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('quantity-selector').then(() => {
      // 初始化所有现有的 quantity-selector
      document.querySelectorAll('quantity-selector').forEach(fixQuantitySelector);

      // 观察新添加的 quantity-selector（用于动态内容如快速购买抽屉）
      const quantityObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // 检查节点本身是否是 quantity-selector
              if (node.tagName === 'QUANTITY-SELECTOR') {
                fixQuantitySelector(node);
              }
              // 检查节点内部是否有 quantity-selector
              const selectors = node.querySelectorAll && node.querySelectorAll('quantity-selector');
              if (selectors) {
                selectors.forEach(fixQuantitySelector);
              }
            }
          });
        });
      });

      quantityObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }).catch(err => {
      console.error('[Quantity Fix] Error:', err);
    });
  }
});
